import { connect } from "scrivito"
import { AuthContext } from "shared/context/AuthContext"

import { useAuthProvider } from "./hooks/useAuthProvider"

function AuthProviderComponent({ children }: { children: React.ReactNode }) {
  return (
    <AuthContext.Provider value={useAuthProvider()}>
      {children}
    </AuthContext.Provider>
  )
}

export const AuthProvider = connect(AuthProviderComponent)
